module.exports = __webpack_public_path__ + "static/1-5102cac6d30f1655635b60755a6b7b9c.jpg";